<div class="logo">
    <span class="paw-icon"></span>
</div>